import { Box } from "@mui/system";
import { SimpleModal, ButtonCust } from "../../../widgets";


type Props = {
  modalFg: boolean;
  closeHandler?: any;
  content:any;
};

export function PayFailureModal(props: Props) {
  const { modalFg, closeHandler, content } = props;
  const { info, pay_fail_img, title, try_btn } =
    content?.pay_fail_md;
  return (
    <SimpleModal
      isShowModal={modalFg}
      onCloseModal={closeHandler}
      showClose={true}
      sx={{ width: { xs: "95%", sm: "60%", md: "55%", lg: "50%", xl: "45%" } }}
      style={{ borderRadius: "4px" }}
    >
      <Box
        display="flex"
        flexDirection="column"
        p={1}
        pt={0.5}
        alignItems="center"
      >
        <Box
          sx={{
            fontSize: "22px",
            color: "var(--text_color)",
            fontWeight: "var(--font_weight_4)",
          }}
        >
          {title}
        </Box>
        <Box
          sx={{
            margin: "20px auto 25px",
            width: "80px",
            height: "5px",
            borderRadius: "2.5px",
            backgroundColor: "var(--primary_brand_color)",
          }}
        ></Box>
        <Box display="flex" alignItems="center">
          <img
            src={pay_fail_img?.data?.attributes?.url}
            alt={pay_fail_img?.data?.attributes?.alternativeText}
            style={{ width: "40px", height: "32px" }}
          />
        </Box>
        <Box
          pt={2}
          sx={{
            fontSize: "14px",
            color: "var(--text_color)",
            textAlign: "center",
            fontFamily:"var(--font_family_Medium)"
          }}
        >
          {info}
        </Box>
        <Box pt={3}>
          <ButtonCust onClick={closeHandler}>{try_btn}</ButtonCust>
        </Box>
      </Box>
    </SimpleModal>
  );
}
